module.exports = __webpack_public_path__ + "static/media/left.ef895e2e.svg";